import FlashMessage from './FlashMessage';

export default FlashMessage;



// WEBPACK FOOTER //
// ./src/components/shared/FlashMessage/index.js